import { View } from 'react-native'
import styled, { css } from 'styled-components/native'
import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import { baseColors } from 'APP/Theme/themeUtils'

export type CardVariant = 'success' | 'info' | 'error' | 'neutral' | 'accent' | 'highlight'

const variantBorderColor: Partial<Record<CardVariant, keyof typeof baseColors>> = {
  success: 'success',
  info: 'bannerBg',
  error: 'error',
  neutral: 'disabled',
  accent: 'accent',
}

const variantBgColor: Partial<Record<CardVariant, keyof typeof baseColors>> = {
  info: 'bannerBg',
  highlight: 'clientCardBg',
}

type StyledVariantProps = { variant?: CardVariant }

const cardBase = css<StyledVariantProps>`
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  ${({ theme, variant }) => variant === undefined && theme.shadows.normal};
`

const variantStyles = css<StyledVariantProps>`
  ${({ theme, variant }) => {
    if (variant === undefined) return ''
    const borderColorKey = variantBorderColor[variant]
    const bgColorKey = variantBgColor[variant]
    return css`
      ${borderColorKey &&
      `
        border-width: 1px;
        border-color: ${theme.colors[borderColorKey]};
      `}
      ${bgColorKey && `background-color: ${theme.colors[bgColorKey]};`}
    `
  }}
`

export const StyledView = styled(View)<StyledVariantProps>`
  ${cardBase}
  ${variantStyles}
`

export const StyledTouchableOpacity = styled(DialogueTouchableOpacity)<StyledVariantProps>`
  ${cardBase}
  ${variantStyles}
`
